import {ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import {AuthService} from '../../shared-component/service/auth/auth.service';
import {LoanService} from '../../shared-component/service/loan/loan.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'ap-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {
  public profileData: any = {};
  public passwordForm: FormGroup;
  public changePasswordMessage: boolean = false;
  public elem;
  public isFullscreenActive = false;
  public isTokenSession: boolean = false;

  @Output() myEvent = new EventEmitter();
  @ViewChild('popup') popUp: any;

  constructor(
    public router: Router,
    public auth: AuthService,
    public loanService: LoanService,
    public fb: FormBuilder,
    public modalService: NgbModal,
    @Inject(DOCUMENT) private document: any,
    private cdr: ChangeDetectorRef
  ) {
    this.passwordForm = fb.group({
      password: ['', Validators.compose([Validators.required])],
      confirmPassword: ['', Validators.compose([Validators.required])]
    });
  }

  ngOnInit() {
    this.loanService.profile().subscribe((res: any) => {
      this.profileData = res.data;
      this.auth.isTokenSession(sessionStorage.getItem('partner_token').replace("Bearer ", "")).subscribe((res: any) => {
        this.isTokenSession = res.data.isSession;
        if (!this.isTokenSession && this.profileData.passwordChangeRequired) {
          this.openPopup();
        }
      });
    });
    this.elem = document.documentElement;
    document.addEventListener('fullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('mozfullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('webkitfullscreenchange', () => this.checkFullScreenStatus());
    document.addEventListener('msfullscreenchange', () => this.checkFullScreenStatus());
    this.checkFullScreenStatus();
  }

  get password() {
    return this.passwordForm.get('password');
  }

  get confirmPassword() {
    return this.passwordForm.get('confirmPassword');
  }

  logout() {
    this.auth.logout(sessionStorage.getItem('partner_token')).subscribe(() => {
      sessionStorage.removeItem('partner_token');
      this.router.navigate(['/authentication']);
    });
  }

  changePassword() {
    this.auth.newPassword(this.passwordForm.value).subscribe(() => {
      this.profileData.passwordChangeRequired = false;
      this.changePasswordMessage = true;
    }, (errors) => {
      for (let error of errors) {
        if (!this.passwordForm.get(error.field)) continue;
        this.passwordForm.get(error.field).setErrors({server: error.message});
      }
    });
  }

  toggleSidebar() {
    this.myEvent.emit();
  }

  open(content) {
    this.modalService.open(content, {
      backdrop: 'static',
      beforeDismiss: () => {
        return !this.profileData.passwordChangeRequired;
      }
    });
  }

  openPopup() {
    this.open(this.popUp);
  }

  onSubmit() {
    this.router.navigateByUrl(`/loanApplication`).then();
  }
  
  onSubmitLead() {
    this.router.navigateByUrl(`/loanApplication/lead`).then();
  }

  checkFullScreenStatus() {
    if (document.fullscreenElement) {
      this.isFullscreenActive = true;
    } else {
      this.isFullscreenActive = false;
    }
  }

  openFullscreen() {
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  /* Close fullscreen */
  closeFullscreen() {
    if (document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }
}
